<template>
  <NuxtLayout
    name="generic"
    header="standardWhite"
    footer="standard"
  >
    <main v-if="data">
      <WhyOnshapeHero :data="data.whyOnshapeHero" />

      <SectionBuilder
        v-if="data.content"
        v-bind="data.content"
        :class="{
          'text-www-color-neutral-medium-dark': true,
          'why-onshape': true,
        }"
      />
    </main>
  </NuxtLayout>
</template>

<script setup lang="ts">
import type { QueryWhyOnshapeResult } from '~/sanity/types';
import { queryWhyOnshape } from '~/queries/pages/PageWhyOnshape.query';
import WhyOnshapeHero from '~/components/Organisms/WhyOnshapeHero/WhyOnshapeHero.vue';
import SectionBuilder from '~/components/Organisms/SectionBuilder/SectionBuilder.vue';
import { extractAbstractFromSectionBuilder } from '~/utils/extractBreakoutSummary';

const { path: currentPathname } = useRoute();

const { data } = await useWwwSanityQueryNonNull<QueryWhyOnshapeResult>(queryWhyOnshape, {
  currentPathname,
});
usePageHead({
  _id: data.value?._id,
  description: data.value?.ogDescription || data.value?.description,
  ogImage:
    data.value?.ogImage?.asset || data.value?.cardImage?.asset || data.value?.heroImage?.asset,
  title: data.value?.htmlTitle || data.value?.whyOnshapeHero.title,
  excludeFromExternalSearch: data.value?.excludeFromExternalSearch,
  twitterCard: 'summary',
  structuredData: [
    {
      schemaType: 'CreativeWork',
      title: data.value?.htmlTitle || data.value?.whyOnshapeHero.title,
      description: data.value?.ogDescription || data.value?.description,
      abstract: extractAbstractFromSectionBuilder(data.value?.content),
      enabled: true,
    },
  ],
});
</script>
<style>
/* to custom anchor tags in animated Two Columns in why-onshape page */
.why-onshape a {
  text-decoration: none !important;
  text-transform: uppercase;
  font-size: 1.25rem;
  font-family: 'Rajdhani', sans-serif;
}
</style>
